import { render, staticRenderFns } from "./TicketIcon.vue?vue&type=template&id=9dd23f54&"
import script from "./TicketIcon.vue?vue&type=script&lang=ts&"
export * from "./TicketIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports